<template>
    <div class="overlay">
        <div class="overlay__inner">
            <div class="overlay__content"><span class="spinner"></span></div>
        </div>
    </div>
</template>

<script>

export default {
    name: "PageLoader",
    data() {
        return {};
    }
};
</script>
